<template>
  <div>
    <!-- <Search class="mr-2 mb-3" /> -->
    <div class="row align-items-end">
      <div class="col-auto flex-grow-1">
        <div class="form-group">
          <label for="select_1_1">Поиск</label>
          <div class="input-affix">
            <i class="prefix-icon anticon anticon-search"></i>
            <input
              type="text"
              class="form-control"
              v-model="searchText"
              placeholder="Поиск"
            />
          </div>
        </div>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-primary mb-4 ml-auto d-block"
          style="white-space: nowrap"
          @click="addModalShow"
        >
          Добавить
        </button>
      </div>
    </div>
    <hr class="mt-0 mb-2" />
    <template v-if="newSearchList.length">
      <div class="row align-items-center" v-if="newSearchList.length">
        <div class="col-auto mr-auto mb-2">
          <PerPageLenth
            class="mr-3"
            :page="page"
            :perPage="perPage"
            :allDataLenth="newSearchList.length"
          />
          <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
        </div>
        <div class="col-auto mb-2">
          <button
            class="btn btn-sm btn-icon btn-secondary btn-tone excel"
            @click="downloadFile"
          >
            <i class="anticon anticon-file-excel"></i>
          </button>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
    </template>
    <template v-if="newSearchList.length">
      <table
        class="table table-sm table-responsive-md table-striped table-hover"
      >
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Кыргызча</th>
            <th scope="col">Русский</th>
            <th scope="col">English</th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин.
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in newDatalist" :key="item.id">
            <th scope="row">{{ index + perPage * (page - 1) + 1 }}</th>
            <td>{{ item.name_kg }}</td>
            <td>{{ item.name_ru }}</td>
            <td>{{ item.name_en }}</td>
            <td class="text-center">{{ item.id_integration }}</td>

            <td class="text-right">
              <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
              <button
                class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                @click="editModalShow(index)"
              >
                <i class="anticon anticon-edit"></i>
              </button>
              <button
                class="btn btn-icon btn-sm btn-danger btn-tone"
                @click="deleteModalShow(index, item.id)"
              >
                <i class="anticon anticon-delete"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </template>
    <div v-else class="noTdData">Нет данных</div>

    <Pagination
      :total="newSearchList.length"
      :perPage="perPage"
      @activePage="currentPage"
    />
    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title> Добавить страну </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="country.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="country.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="country.val.name_en"
            required
          />
        </div>

        <div class="form-group">
          <label for="in_1">№ Интеграции</label>
          <input
            type="text"
            class="form-control"
            id="in_1"
            v-model="country.val.id_integration"
            required
          />
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="addModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="addPost">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Изменить страну </template>
      <template v-if="newDatalist.length">
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="country.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="country.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="country.val.name_en"
            required
          />
        </div>
        <div class="form-group">
          <label for="in_l">№ Интеграции</label>
          <input
            type="text"
            class="form-control"
            id="in_l"
            v-model="country.val.id_integration"
            required
          />
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="editModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="editcountry">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Удалить страну </template>

      <template>
        <h5>Вы действительно хотите удалить?</h5>
        <template v-if="newDatalist.length && dindex != null">
          <p>{{ newDatalist[dindex].name_kg }}</p>
          <p>{{ newDatalist[dindex].name_ru }}</p>
          <p>{{ newDatalist[dindex].name_en }}</p>
        </template>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="deletecountry"
        >
          Подтвердить
        </button>
      </template>
    </Modal>
  </div>
</template>
<script>
import xlsx from "json-as-xlsx";

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
// import Search from '@/components/others/Search.vue'
import Modal from "@/components/others/Modal.vue";

// import fakec from "@/data/country.js";

export default {
  name: "Country",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  data() {
    return {
      exelIcon: require("@/assets/images/others/excel.png"),
      isAddModalShow: false,
      isEditModalShow: false,
      isDeleteModalShow: false,
      country: { id: null, items: [], val: {} },
      dindex: null,
      did: null,
      page: 1,
      perPage: 10,
      searchText: "",
    };
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.country.items.filter((x) => x.name_kg.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    downloadFile() {
      let data = [
        {
          sheet: "Страны",
          columns: [
            { label: "id", value: "id" },
            { label: "Кыргызча", value: "name_kg" },
            { label: "Русский", value: "name_ru" },
            { label: "English", value: "name_en" },
            { label: "Интеграция", value: "id_integration" },
          ],
          content: this.newSearchList,
        },
      ];
      let settings = {
        fileName: "Cтраны",
      };
      xlsx(data, settings);
    },
    addModalShow() {
      this.country.val = {};
      this.isAddModalShow = true;
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    editModalShow(index) {
      this.country.val = { ...this.newDatalist[index] };
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.isEditModalShow = false;
    },
    deleteModalShow(index, id) {
      this.isDeleteModalShow = true;
      this.dindex = index;
      this.did = id;
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    async get_country() {
      try {
        const data = (await this.$api.place.country()).data;
        this.country.items = data;
      } catch (error) {
        console.log(error);
      }
    },
    async add_country() {
      try {
        await this.$api.placeSchool.add_country(this.country.val);
        this.$nt("Успешно сохранен", "success");

        this.country.val = {};
        this.addModalClose();
        this.get_country();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранения", "dagner");
      }
    },
    async update_country() {
      try {
        await this.$api.placeSchool.update_country(this.country.val);
        this.$nt("Успешно изменен", "success");
        this.country.val = {};
        this.editModalClose();
        this.get_country();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка изменения", "dagner");
      }
    },
    async delete_country() {
      try {
        await this.$api.placeSchool.delete_country({ id: this.did });
        this.$nt("Успешно удален", "success");
        this.dindex = null;
        this.deleteModalClose();
        this.get_country();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка удаления", "dagner");
      }
    },
    addPost() {
      this.add_country();      
    },
    editcountry() {
      this.update_country();     
    },
    deletecountry() {
      this.delete_country();      
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.get_country();
      // this.country.items = fakec;
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
</style>
